/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DeviceFirmwareVersionInfoDto } from '../models/DeviceFirmwareVersionInfoDto';
import type { DeviceType } from '../models/DeviceType';
import type { ParseDeviceFirmwareDto } from '../models/ParseDeviceFirmwareDto';
import type { ParseFirmwareRequest } from '../models/ParseFirmwareRequest';
import type { UpdateDeviceFirmwareRequest } from '../models/UpdateDeviceFirmwareRequest';
import type { UploadDeviceFirmwareRequest } from '../models/UploadDeviceFirmwareRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class DeviceFirmwareService {
    /**
     * @param formData
     * @returns any OK
     * @throws ApiError
     */
    public static postApiDeviceFirmwares(
        formData?: UploadDeviceFirmwareRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/device-firmwares',
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }
    /**
     * @param page
     * @param pageSize
     * @param search
     * @param deviceType
     * @returns any OK
     * @throws ApiError
     */
    public static getApiDeviceFirmwares(
        page: number = 1,
        pageSize: number = 20,
        search?: string,
        deviceType?: DeviceType,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/device-firmwares',
            query: {
                'Page': page,
                'PageSize': pageSize,
                'Search': search,
                'DeviceType': deviceType,
            },
        });
    }
    /**
     * @param formData
     * @returns ParseDeviceFirmwareDto OK
     * @throws ApiError
     */
    public static postApiDeviceFirmwaresParse(
        formData?: ParseFirmwareRequest,
    ): CancelablePromise<ParseDeviceFirmwareDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/device-firmwares/parse',
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }
    /**
     * @param id
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static putApiDeviceFirmwares(
        id: string,
        requestBody: UpdateDeviceFirmwareRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/device-firmwares/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param id
     * @returns any OK
     * @throws ApiError
     */
    public static getApiDeviceFirmwares1(
        id: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/device-firmwares/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @param id
     * @returns any OK
     * @throws ApiError
     */
    public static deleteApiDeviceFirmwares(
        id: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/device-firmwares/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @param id
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static putApiDeviceFirmwaresFile(
        id: string,
        requestBody: Blob,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/device-firmwares/{id}/file',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param id
     * @returns any OK
     * @throws ApiError
     */
    public static deleteApiDeviceFirmwaresFile(
        id: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/device-firmwares/{id}/file',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @param deviceType
     * @returns any OK
     * @throws ApiError
     */
    public static getApiDeviceFirmwaresVersions(
        deviceType?: DeviceType,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/device-firmwares/versions',
            query: {
                'DeviceType': deviceType,
            },
        });
    }
    /**
     * @param id
     * @returns any OK
     * @throws ApiError
     */
    public static getApiDeviceFirmwaresHistory(
        id: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/device-firmwares/{id}/history',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @param id
     * @returns any OK
     * @throws ApiError
     */
    public static getApiDeviceFirmwaresDownload(
        id: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/device-firmwares/{id}/download',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @param deviceType
     * @param currentVersion
     * @returns DeviceFirmwareVersionInfoDto OK
     * @throws ApiError
     */
    public static getApiDeviceFirmwaresCurrent(
        deviceType: DeviceType,
        currentVersion: string,
    ): CancelablePromise<DeviceFirmwareVersionInfoDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/device-firmwares/current',
            query: {
                'DeviceType': deviceType,
                'CurrentVersion': currentVersion,
            },
            errors: {
                404: `Not Found`,
            },
        });
    }
}
